import { createTheme } from '@mui/material/styles';


export const theme = createTheme({
  palette: {
    mode: 'light', // Enforce light mode
    primary: {
      main: '#07332c', // Your primary color
    },
    secondary: {
      main: '#dc004e', // Your secondary color
    },
    background: {
      default: '#fff', // Light background
      paper: '#f5f5f5', // Light paper background
    },
    text: {
      primary: '#000', // Dark text for light mode
      secondary: '#555',
    },
    typography: {
      fontFamily: '"Poppins", "Helvetica", "Arial", sans-serif',
    },
  },
  // Other theme configurations
});